import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useApiCall } from "../../../../hooks/useApiCall";
import i18nStore from "../../../../i18n/store";
import CreateNewButton from "../../../../ui/CreateNewButton";
import { NodeInterface } from "../../../tables/schemas/nodes";
import { SCCCalcApi } from "../../api";
import { CalcNodeInterface, ChartInterface } from "../../schemas";
import VectorChart from "./VectorChart";


interface ChartListProps {
    nodes: NodeInterface[];
    calcNodes: CalcNodeInterface[];
}
const ChartList = observer((props: ChartListProps) => {
    const translations = i18nStore.getTranslations;
    const params = useParams();
    const projectId: number = +(params.projectId || 0);

    const getResultChartsApi = useApiCall(() => SCCCalcApi.getCharts(projectId), []);

    useEffect(() => {
        if (projectId) {
            getResultChartsApi.apiCaller();
        }
    }, [projectId]);

    const onCreateNodeChartClick = () => {
        SCCCalcApi.createChart(projectId).then((chart) => {
            getResultChartsApi.setData([
                chart,
                ...getResultChartsApi.data,
            ])
        });
    };

    const onDuplicateChart = (project_id: number, chart_id: number) => {
        let newChartList: ChartInterface[] = [];

        SCCCalcApi.duplicateChart(project_id, chart_id).then(newChart => {
            for (let i = 0; i < getResultChartsApi.data.length; i++) {
                if(getResultChartsApi.data[i].id === chart_id) {
                    newChartList.push(newChart);
                }
                newChartList.push(getResultChartsApi.data[i]);
            }
            getResultChartsApi.setData(newChartList);
        });
    };

    return (
        <Box>
            <CreateNewButton text={translations.create} onClick={onCreateNodeChartClick} />
            <Grid container spacing={1} sx={{ pt: 1 }}>
                {
                    getResultChartsApi.data.length > 0 && getResultChartsApi.data
                        .map((chart: ChartInterface) => (
                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3}} key={chart.id}>
                                <VectorChart
                                    nodes={props.nodes}
                                    calcNodes={props.calcNodes}
                                    chart={chart}
                                    onDuplicateChart={onDuplicateChart}
                                />
                            </Grid>
                    ))
                }
            </Grid>
        </Box>
    );
});

export default ChartList;